import { Award, Leaf, Sprout, ChefHat, NotebookPen } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: Award, label: "25+ Years Experience" },
  { icon: Leaf, label: "100% Pure Vegetarian" },
  { icon: Sprout, label: "Jain Food Available" },
  { icon: ChefHat, label: "Professional Service" },
  { icon: NotebookPen, label: "Customised Menus" },
];

export const TrustBar = () => (
  <section id="trust" data-testid="trust-bar" className="bg-espresso-dark border-y gold-hairline">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 grid grid-cols-2 md:grid-cols-5 gap-6">
      {ITEMS.map(({ icon: Icon, label }, i) => (
        <Reveal key={label} delay={i * 0.08} y={20}>
          <div className="flex items-center gap-3 justify-center" data-testid={`trust-item-${i}`}>
            <Icon size={20} className="text-gold shrink-0" strokeWidth={1.5} />
            <span className="text-cream/80 text-xs md:text-sm tracking-[0.15em] uppercase">{label}</span>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
